require("./graphic");

var _zrender = require("../zrender");

var registerPainter = _zrender.registerPainter;

var Painter = require("./Painter");

registerPainter('svg', Painter);


//////////////////
// WEBPACK FOOTER
// ./~/_zrender@4.3.2@zrender/lib/svg/svg.js
// module id = 1480
// module chunks = 128